import { SectionPlane, SectionBox } from '@data-access/connect/tc-tcps';
import { Quaternion, Vector3 } from '@technology/web3d';
import {
  convertConnectPointToViewerPoint,
  convertConnectDirectionToViewerDirection,
} from '../views/camera-conversion';
import { convertMetersToMillimeters } from '@trimble/utilities';

/**
 * Convert Connect section plane to viewer clip plane
 */
export function convertConnectSectionPlaneToViewerClipPlane(
  sectionPlane: SectionPlane
): { normal: Vector3; position: Vector3 } {
  return {
    normal: convertConnectDirectionToViewerDirection(
      sectionPlane.directionX,
      sectionPlane.directionY,
      sectionPlane.directionZ
    ),
    position: convertConnectPointToViewerPoint(
      sectionPlane.positionX,
      sectionPlane.positionY,
      sectionPlane.positionZ
    ),
  };
}

/**
 * Convert Connect section box to viewer clip box
 */
export function convertConnectSectionBoxToViewerClipBox(
  sectionBox: SectionBox
): { position: Vector3; quaternion: Quaternion; size: Vector3 } {
  return {
    position: convertConnectPointToViewerPoint(
      sectionBox.positionX,
      sectionBox.positionY,
      sectionBox.positionZ
    ),
    quaternion: new Quaternion(
      sectionBox.rotationX,
      sectionBox.rotationY,
      sectionBox.rotationZ,
      sectionBox.rotationW
    ),
    size: convertConnectPointToViewerPoint(
      sectionBox.sizeX,
      sectionBox.sizeY,
      sectionBox.sizeZ
    ),
  };
}

/**
 * Convert viewer clip plane to Connect section plane format
 */
export function convertViewerClipPlaneToConnectSectionPlane(
  position: Vector3,
  normal: Vector3
): SectionPlane {
  return {
    positionX: convertMetersToMillimeters(position.x),
    positionY: convertMetersToMillimeters(position.y),
    positionZ: convertMetersToMillimeters(position.z),
    directionX: -normal.x,
    directionY: -normal.y,
    directionZ: -normal.z,
  };
}

/**
 * Convert viewer clip box to Connect section box format
 */
export function convertViewerClipBoxToConnectSectionBox(
  position: Vector3,
  quaternion: Quaternion,
  size: Vector3
): SectionBox {
  return {
    positionX: convertMetersToMillimeters(position.x),
    positionY: convertMetersToMillimeters(position.y),
    positionZ: convertMetersToMillimeters(position.z),
    sizeX: convertMetersToMillimeters(size.x),
    sizeY: convertMetersToMillimeters(size.y),
    sizeZ: convertMetersToMillimeters(size.z),
    rotationX: quaternion.x,
    rotationY: quaternion.y,
    rotationZ: quaternion.z,
    rotationW: quaternion.w,
  };
}
